/**
 * 
 * Select Box
 * 
 */

import React from 'react';
import { Dropdown } from 'primereact/dropdown';
import { DROPDOWN_CONFIG } from '../../Config';

class SelectBox extends React.Component {

    render() {
        const { name, label, value, placeholder, fieldStatus, metaData, onInputChange, disabled, readonly } = this.props;
        const display = fieldStatus && fieldStatus === "Display Only";
        
        return (<div className="p-col-12">
            {!display ? <label className="label">
                {label}
                {/* <span className="requiredColor">*</span> */}
            </label> : null}
            <div className={display ? "mt3" : "mt1"}>
                <Dropdown
                    readOnly={readonly}
                    placeholder={placeholder}
                    options={metaData && metaData[label] && Array.isArray(metaData[label]) && metaData[label]}
                    value={value}
                    name={name}
                    onChange={onInputChange}
                    style={{ width: '100%' }}
                    disabled={disabled}
                    {...DROPDOWN_CONFIG} />
            </div>
        </div>)
    }
}


export default SelectBox;